// src/api.ts
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const clientLogin = async (username: string, password: string) => {
  const response = await axios.post(`${API_BASE_URL}/api/ClientAuth/login`, {
    username,
    password,
  });
  return response.data;
};

export const resetClientPassword = async (token: string, newPassword: string) => {
  const response = await axios.post(`${API_BASE_URL}/api/ClientAuth/reset-password`, {
    newPassword,
  }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const fetchClientForms = async (token: string) => {
  const response = await axios.get(`${API_BASE_URL}/api/ClientForms`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const fetchFormById = async (id: number, token: string) => {
  const response = await axios.get(`${API_BASE_URL}/api/Forms/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const updateFormById = async (id: number, jsonData: string, status: string, token: string) => {
  const response = await axios.put(`${API_BASE_URL}/api/Forms/${id}`, {
    jsonData,
    status,
  }, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const createClientAccount = async (clientId: string, username: string, password: string, email: string, token: string) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/Clients/${clientId}/create-client-account`,
    {
      username,
      password,
      email,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const getClientAccount = async (clientId: string, token: string) => {
  const response = await axios.get(`${API_BASE_URL}/api/Clients/${clientId}/client-account`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const resetClientAccountPassword = async (clientId: string, newPassword: string, token: string) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/Clients/${clientId}/reset-client-password`,
    {
      newPassword,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};